import script from "./singlecell_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./singlecell_detail.vue?vue&type=script&setup=true&lang=js"

import "./singlecell_detail.vue?vue&type=style&index=0&id=2dd7586c&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\项目\\zhangh\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd7586c"]])

export default __exports__